import React, { Dispatch, FC, ReactNode, SetStateAction } from 'react';
import cn from 'classnames';

import './ToggleSwitch.scss';

type ToggleSwitchProps = {
  switcherState: boolean;
  setSwitcherState: Dispatch<SetStateAction<boolean>>;
  values: Array<string | ReactNode>;
  disabled?: boolean;
  className?: string;
  size?: number;
};

const ToggleSwitch: FC<ToggleSwitchProps> = ({
  switcherState,
  setSwitcherState,
  values,
  size = 1,
  className = '',
  disabled = false,
}) => (
  <div className={cn('toggle-switch', className)} style={{ transform: `scale(${size})` }}>
    <button
      className={cn(
        'toggle-option',
        switcherState && 'active',
        disabled && 'toggle-switch-disabled',
      )}
      onClick={() => setSwitcherState(!switcherState)}
      disabled={disabled}
    >
      {values[0]}
    </button>
    <button
      className={cn(
        'toggle-option',
        !switcherState && 'active',
        disabled && 'toggle-switch-disabled',
      )}
      onClick={() => setSwitcherState(!switcherState)}
      disabled={disabled}
    >
      {values[1]}
    </button>
    <div className={`toggle-slider ${switcherState ? 'bottom' : 'top'}`} />
  </div>
);

export default ToggleSwitch;
